import { BoxProps } from '@material-ui/core/Box';
import { ButtonBaseProps } from '@material-ui/core/ButtonBase';
import React, { FC } from 'react';
import { IconButton, Theme } from '@material-ui/core';
import styled from '@material-ui/styles/styled';

type TrajectoryBarButtonProps = BoxProps & ButtonBaseProps & { variant?: 'filled' | 'default' };

const StyledFlexContainer = styled(IconButton)<Theme, TrajectoryBarButtonProps>(
  ({ theme, variant = 'default' }) => ({
    background: variant === 'filled' ? theme.palette.primary.main : theme.palette.common.white,
    color: variant === 'filled' ? theme.palette.common.white : theme.palette.primary.main,
    border: '.1rem solid',
    borderColor: variant === 'filled' ? theme.palette.primary.main : theme.palette.grey[200],
    padding: 0,
    borderRadius: 0,
    width: 22,
    height: 22,
    '&:hover': {
      background: variant === 'filled' ? theme.palette.common.white : theme.palette.primary.main,
      color: variant === 'filled' ? theme.palette.primary.main : theme.palette.common.white,
    },
  })
);

export const SidebarButton: FC<TrajectoryBarButtonProps> = ({ variant, ...props }) => {
  return <StyledFlexContainer {...props} variant={variant} />;
};
